<template>
  <v-app>
    <!-- Only render the main layout AFTER auth state is initialized -->
    <template v-if="!authStore.loading">
      <!-- Show main UI only if authenticated -->
      <template v-if="authStore.isAuthenticated">
        <!-- Navigation Drawer -->
        <v-navigation-drawer v-model="drawer">
          <v-list>
            <v-list-item title="SafeTelecom Dashboard" class="text-h6"></v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list density="compact" nav>
            <v-list-item to="/" title="Dashboard" prepend-icon="mdi-view-dashboard"></v-list-item>
            <v-list-item to="/clients" title="Clients" prepend-icon="mdi-account-multiple"></v-list-item>
            <v-list-item to="/tenants" title="Tenants" prepend-icon="mdi-domain"></v-list-item>
            <v-list-item to="/ota" title="OTA Management" prepend-icon="mdi-update"></v-list-item>
          </v-list>
        </v-navigation-drawer>

        <!-- App Bar -->
        <v-app-bar>
          <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
          <v-toolbar-title>Dashboard</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-menu location="bottom end">
            <template v-slot:activator="{ props }">
              <v-btn icon v-bind="props">
                <v-icon>mdi-account-circle</v-icon>
              </v-btn>
            </template>
            <profile-menu />
          </v-menu>
        </v-app-bar>
      </template>

      <!-- Main Content -->
      <v-main>
        <v-container fluid>
          <router-view />
        </v-container>
      </v-main>
    </template>
    
    <!-- Optional: Add a loading indicator while authStore.loading is true -->
    <v-overlay :model-value="authStore.loading" class="align-center justify-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
import { defineComponent, ref } from 'vue'
import ProfileMenu from './components/ProfileMenu.vue'
import { useAuthStore } from '@/store/auth' // Import the auth store

export default defineComponent({
  name: 'App',
  components: {
    ProfileMenu
  },
  setup() {
    const drawer = ref(true)
    const authStore = useAuthStore() // Use the auth store

    return {
      drawer,
      authStore // Expose store to template
    }
  }
})
</script>